import { publicFetch } from './http';

export interface OnboardingState {
  tenantId: string;
  productCode: string;
  step: number;
  status: string;
  awsAccountId?: string;
}

export interface OnboardingStepUpdate {
  step: number;
  status: string;
  data?: Record<string, unknown>;
}

// Customer-facing onboarding. The customer arrives on /onboard with a one-time
// token and has NO Cognito session, so these two calls are intentionally
// unauthenticated and must stay on the public `/onboard/*` routes. Everything
// under `/ops/*` requires a bearer token (see ./http).

/** Resolve a one-time onboarding token to its tenant/product state. */
export async function resolveOnboardingToken(token: string): Promise<OnboardingState> {
  return publicFetch<OnboardingState>(`/onboard/${token}`);
}

/**
 * Advance the customer's onboarding step.
 *
 * Uses the public `POST /onboard/step` route. This previously wrote through
 * `PUT /ops/tenants/{tenantId}/products/{productId}`, which forced the whole
 * `/ops/*` surface to stay unauthenticated for the customer flow to work.
 * `/onboard/step` performs the same DynamoDB update (and the step>=6 activation)
 * so the internal control plane can be locked down without breaking onboarding.
 */
export async function updateOnboardingStep(
  tenantId: string,
  productId: string,
  update: OnboardingStepUpdate
): Promise<unknown> {
  return publicFetch('/onboard/step', {
    method: 'POST',
    body: JSON.stringify({
      tenantId,
      productCode: productId,
      step: update.step,
      data: update.data,
    }),
  });
}
